export default {
	'light': () => (() => {}),
	'light-future': () => (() => {}),
	'dark': () => (() => {}),
	'dark-future': () => (() => {}),
	'legacy-light': () => (() => {}),
	'legacy-dark': () => (() => {}),
	'spacing': () => (() => {}),
	'shape': () => (() => {}),
	'typography-adg3': () => (() => {}),
	'typography-modernized': () => (() => {}),
	'typography-refreshed': () => (() => {}),
};